import { useEffect, useState } from 'react';
import { t } from '@lingui/macro';

import FormSection from '../../form/FormSection';
import { useGroupAdminStyles } from './GroupsAdminUtils';
import ListSelectorField from '../../form/ListSelectorField';
import { useDataService } from '../../../services/ApiDataService';
import { SORT_ASC } from '../../../utilities/FormUtilities';
import { GROUPS_ADMIN_USERS_COLUMNS, GROUPS_ADMIN_USERS_FIELD } from './GroupsAdminConstants';

const initialSort = [{ property: 'userName', direction: SORT_ASC }];

const userRowRemovalCondition = (row, isEditingDefaultGroup) => {
    if (isEditingDefaultGroup) {
        return row.source !== 'default';
    }

    return true;
};

export function GroupsAdminUsersSection({ formData, usersRef, setUsersSelectionIsDirty, isEditingDefaultGroup }) {
    const styles = useGroupAdminStyles();
    const [users, setUsers] = useState([]);
    const dataService = useDataService();

    useEffect(() => {
        (async () => {
            let usersData = await dataService.get('/ipm/v1/admin/users');
            if (!isEditingDefaultGroup) {
                usersData = usersData.filter((user) => user.source !== 'default');
            }

            usersRef.current = usersData;
            setUsers(usersData);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <FormSection title={t`Users`}>
            <div className={styles.selectorWrapper}>
                <ListSelectorField
                    gridColumns={GROUPS_ADMIN_USERS_COLUMNS}
                    dataArray={users}
                    dataArraySearchFields={['userName', 'firstName', 'lastName', 'userRole', 'email']}
                    sorters={initialSort}
                    dbSelected={formData?.users || []}
                    fieldName={GROUPS_ADMIN_USERS_FIELD}
                    addButtonText={t`Add Users`}
                    removeButtonText={t`Remove`}
                    setSelectionIsDirty={setUsersSelectionIsDirty}
                    selectedEmptyGridText={t`There are no Users in this Group`}
                    rowRemovalCondition={(row) => userRowRemovalCondition(row, isEditingDefaultGroup)}
                />
            </div>
        </FormSection>
    );
}
